import React, { useState } from 'react';
import { Panel } from 'primereact/panel';

export default function MetaTagsLiveCodePreview({ metaTags }) {
  const [collapsed, setCollapsed] = useState(true);

  const renderMetaTagCode = (metaTag, index) => {
    const { type, attributes, self_closing, content } = metaTag;
    const truncate = (str, max = 50) => str && str.length > max ? str.slice(0, max) + '...' : str;
    if (self_closing) {
      return (
          <div key={index}>
         {/* 'self-closing' */}
          <span style={{ color: '#f472b6' }}>{`<${type || ''}`}</span>
          {Object.entries(attributes).map(([key, value]) => (
            <React.Fragment key={key}>
              <br />
              <span style={{ paddingLeft: '1rem', color: '#67e8f9' }}>{key}=</span>
              <span style={{ color: '#fde68a' }}>{`"${truncate(value)}"`}</span>
            </React.Fragment>
          ))}
          <span style={{ color: '#f472b6' }}>{` />`}</span>
          <br />
          <br />
        </div>
      );
    } else {
      // Helper to truncate long values
      

      return (
        <div key={index}>
          <span style={{ color: '#f472b6' }}>{`<${type || ''}`}</span>
          {Object.entries(attributes).map(([key, value]) => (
        <React.Fragment key={key}>
          <br />
          <span style={{ paddingLeft: '1rem', color: '#67e8f9' }}>{key}=</span>
          <span style={{ color: '#fde68a' }}>{`"${truncate(value)}"`}</span>
        </React.Fragment>
          ))}
          <span style={{ color: '#f472b6' }}>{`>`}</span>
          <br />
          <span style={{ paddingLeft: '1rem', color: 'white' }}>{truncate(content || '')}</span>
          <br />
          <span style={{ color: '#f472b6' }}>{`</${type || ''}>`}</span>
          <br />
          <br />
        </div>
      );
    }
  };

  const renderHeadSection = () => {
    // const headTags = metaTags?.filter(tag => 
    //   ['meta', 'link', 'title', 'style', 'script', 'base'].includes(tag.tag.toLowerCase())
    // );

    if (metaTags?.length === 0) return null;

    return (
      <>
        {metaTags?.map(renderMetaTagCode)}
      </>
    );
  };

  return (
    <div className="grid p-justify-center">
      <div className="col-12">
        <Panel
          header="HTML Meta Tags — Live Preview"
          toggleable
          collapsed={collapsed}
          onToggle={(e) => setCollapsed(e.value)}
          expandIcon="pi pi-chevron-down"
          collapseIcon="pi pi-chevron-up"
        >
          <div style={{
            backgroundColor: '#1e293b',
            color: '#f1f5f9',
            borderRadius: '8px',
            overflowX: 'auto',
            padding: '1.5rem',
            fontFamily: 'monospace',
            fontSize: '14px',
            minHeight: '200px'
          }}>
            <pre style={{ margin: 0 }}>
              <code>
                <span style={{ color: '#f472b6' }}>{`<head>`}</span>
                
                <br />
                {/* Head Section */}
                <br />
                {renderHeadSection()}
                
                {/* Body Section */}
                {/* <span style={{ color: '#f472b6' }}>{`<body>`}</span> */}
                {/* {renderBodyTags()} */}
                <br />
                <span style={{ color: '#f472b6' }}>{`</head>`}</span>
              </code>
            </pre>
          </div>
        </Panel>
      </div>
    </div>
  );
}

// export default function MetaTagsLiveCodePreview({ metaTags, fixedTags, showControl = false }) {

//     const [visibleGlobalTags, setVisibleGlobalTags] = React.useState(true);

//     console.log('fixedTags', fixedTags)

//     console.log('metaTags inside', metaTags)

//     return (
//         <div className="grid p-justify-center p-m-4">
//             <div className="col-12">
//                 <Panel header="HTML result">
//                     {
//                         showControl && (

//                             <div className='flex align-items-center mb-2 gap-2'>
//                                 <InputSwitch checked={visibleGlobalTags} onChange={(e) => setVisibleGlobalTags(e.value)}></InputSwitch>
//                                 <label>
//                                     Show global meta tags
//                                 </label>
//                             </div>
//                         )
//                     }
//                     <div style={{
//                         backgroundColor: '#1e293b',
//                         color: '#f1f5f9',
//                         borderRadius: '8px',
//                         overflowX: 'auto',
//                         padding: '1rem',
//                         fontFamily: 'monospace',
//                         fontSize: '14px'
//                     }}>
//                         <pre style={{ margin: 0 }}>
//                             <code>
//                                 <span style={{ color: '#6ee7b7' }}>{`<head>`}</span>
//                                 {/* {
//                                     title && (
//                                         <>
//                                             <br />
//                                             <br /><span style={{ color: '#f472b6' }}>{`<title>`}</span><br />

//                                             {'  '}{title}
//                                             <br />

//                                             <span style={{ color: '#f472b6' }}>{`</title>`}</span>
//                                         </>
//                                     )
//                                 } */}

//                                 {metaTags?.map((tag, idx) => (
//                                     <div key={idx}>
//                                         <br /><span style={{ color: 'gray' }}>{`<!--${tag?.name} -->`}</span><br />
//                                         <span style={{ color: '#f472b6' }}>{`<${tag?.tag}`}</span><br />
//                                         {
//                                             Object.entries(tag?.attributes)?.map(([attr, value], attrIdx) => (
//                                                 <React.Fragment key={attrIdx}>
//                                                     <React.Fragment key={attr}>
//                                                         <span style={{ paddingLeft: '1rem', color: '#67e8f9' }}>{`${attr}=`}</span>
//                                                         <span style={{ color: '#fde68a' }}>{`"${value}"`}</span><br />
//                                                     </React.Fragment>
//                                                 </React.Fragment>
//                                             ))}
//                                         <span style={{ color: '#f472b6' }}>{`/>`}</span>
//                                         <br /><br />
//                                     </div>
//                                 ))}
//                                 <>
//                                     {visibleGlobalTags && fixedTags?.length > 0 && (
//                                         <>
//                                             <br />
//                                             <span style={{ color: 'gray' }}>{`<!--  Global meta tags -->`}</span>
//                                             <br />
//                                             {fixedTags?.map((tag, idx) => (
//                                                 <div key={idx}>
//                                                     <br /><span style={{ color: 'gray' }}>{`<!--${tag?.name} -->`}</span><br />
//                                                     <span style={{ color: '#f472b6' }}>{`<${tag?.tag}`}</span><br />
//                                                     {
//                                                         Object.entries(tag?.attributes)?.map(([attr, value], attrIdx) => (
//                                                             <React.Fragment key={attrIdx}>
//                                                                 <React.Fragment key={attr}>
//                                                                     <span style={{ paddingLeft: '1rem', color: '#67e8f9' }}>{`${attr}=`}</span>
//                                                                     <span style={{ color: '#fde68a' }}>{`"${value}"`}</span><br />
//                                                                 </React.Fragment>
//                                                             </React.Fragment>
//                                                         ))}
//                                                     <span style={{ color: '#f472b6' }}>{`/>`}</span>
//                                                     <br /><br />
//                                                 </div>
//                                             ))}
//                                             <span style={{ color: 'gray' }}>{`<!--  Global meta tags -->`}</span>
//                                             {/* <br /> */}
//                                             {/* <br /> */}

//                                         </>
//                                     )}
//                                 </>
//                                 <br /><br />
//                                 <span style={{ color: '#6ee7b7' }}>{`</head>`}</span>
//                             </code>
//                         </pre>
//                     </div>
//                 </Panel>
//             </div>
//         </div>
//     );
// }
